export class StatisticFilter {
    Units: number[] = [];
    PageSize: number = 0;
    PageIndex: number = 50;
    OrderedByColumName: string;
    OrderedBy: string;
    SearchText: string;   
    UserId: number;
    StatusId: number[] = [];
    Months: number[] = [];
    Year:number;
    statisticId: number[] = [];
    SelectAll: boolean;
    CurrentPage: number;
    Contractors: number[] = [];
    SourceIds : number[] = [];
  }